// Brand assets & boutique info.
// HEATHER_IMG — small circular avatar for "A Note from Heather" cards. Uses
// the editorial NYFW portrait so the note carries the atelier tone (rather
// than the workshop/seamstress shot which lives on the About page timeline).
export const HEATHER_IMG = "https://customer-assets.emergentagent.com/job_site-enhancer-58/artifacts/ap6tc7vt_Heather%20Login.png";
// Landscape / editorial portrait of Heather at NYFW — used on Home "Meet the Woman Behind the Atelier" section.
export const HEATHER_HERO_IMG = "https://customer-assets.emergentagent.com/job_site-enhancer-58/artifacts/ap6tc7vt_Heather%20Login.png";
export const HEATHER_NAME = "Heather Rock";
export const HEATHER_TITLE = "Master Seamstress & Owner";
export const STORE_ADDRESS = "W359N5002 Brown Street Suite#211 Oconomowoc WI 53066";
export const STORE_PHONE = "(888) 450-6525";
export const STORE_HOURS = "Mon–Sat · 11:00 AM – 4:30 PM · Sun Closed";
export const LOGO_H = "https://customer-assets.emergentagent.com/job_occasion-edit/artifacts/u7gy2a3g_image.png";
